import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import AddUser from './components/AdminDashboard/AddUser';
import ViewUsers from './components/AdminDashboard/ViewUsers';
import AddQuestion from './components/AdminDashboard/AddQuestion';
import ViewQuestions from './components/AdminDashboard/ViewQuestions';
import CreatePaperSet from './components/AdminDashboard/CreatePaperSet';
import ViewPaperSets from './components/AdminDashboard/ViewPaperSets';
import AssignPaperSet from './components/AdminDashboard/AssignPaperSet';
import ViewAssignedPaperSets from './components/AdminDashboard/ViewAssignedPaperSets';
import UserDashboard from './components/UserDashboard/UserDashboard';
import StartExam from './components/UserDashboard/StartExam';
import Result from './components/UserDashboard/Result';
import Login from './components/Auth/Login';
import { AuthProvider, useAuth } from './utils/AuthContext';
import AdminRoute from './utils/AdminRoute';
import UserRoute from './utils/UserRoute';
import ModifyUser from './components/AdminDashboard/ModifyUser';
import AssignQuestionsToPaperSet from './components/AdminDashboard/AssignQuestionsToPaperSet';
import ViewQuestionsToPaperSet from './components/AdminDashboard/ViewQuestionsToPaperSet';
import ModifyQuestionsToPaperSet from './components/AdminDashboard/ModifyQuestionsToPaperSet';
import ScreenshotComponent from './components/AdminDashboard/ScreenshotComponent';
import VideoCapture from './components/AdminDashboard/VideoCapture';
import UploadQuestions from './components/AdminDashboard/UploadQuestions';
import Layout from './components/Layout/Layout';
import ExamResult from './components/AdminDashboard/ExamResult';
import Marksheet from './components/AdminDashboard/Marksheet';
import AllUsersMarksheet from './components/AdminDashboard/AllUsersMarksheet';
// import AddCategory from './components/AdminDashboard/AddCategory';
import ViewCategories from './components/AdminDashboard/ViewCategories';
import ModifyCategory from './components/AdminDashboard/ModifyCategory';
import SetQuestionCategory from './components/AdminDashboard/SetQuestionCategory';
import ViewQuestionsByCategory from './components/AdminDashboard/ViewQuestionsByCategory';
import ChangeQuestionCategory from './components/AdminDashboard/ChangeQuestionCategory';
import CategoryManager from './components/AdminDashboard/CategoryManager';
import PaperSetsPage from './components/AdminDashboard/PaperSetsPage';
import ExamResponse from './components/AdminDashboard/ExamResponse';
import LiveStream from './components/AdminDashboard/LiveStream';
import LiveVideo from './components/AdminDashboard/LiveVideo';
const App =  () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/admin/add-user" element={<AdminRoute component={AddUser} />} />
            <Route path="/admin/view-users" element={<AdminRoute component={ViewUsers} />} />
            <Route path="/admin/modify-users" element={<AdminRoute component={ModifyUser} />} />
            <Route path="/admin/add-question" element={<AdminRoute component={AddQuestion} />} />
            <Route path="/admin/view-questions" element={<AdminRoute component={ViewQuestions} />} />
            <Route path="/admin/paper-sets-page" element={<AdminRoute component={PaperSetsPage} />} />
            <Route path="/admin/view-paper-sets" element={<AdminRoute component={ViewPaperSets} />} />
            <Route path="/admin/assign-paper-set" element={<AdminRoute component={AssignPaperSet} />} />
            <Route path="/admin/view-assigned-paper-sets" element={<AdminRoute component={ViewAssignedPaperSets} />} />
            <Route path="/admin/assign-questions-paperset" element={<AdminRoute component={AssignQuestionsToPaperSet} />} />
            <Route path="/admin/view-questions-paperset" element={<AdminRoute component={ViewQuestionsToPaperSet} />} />
            <Route path="/admin/modify-questions-paperset" element={<AdminRoute component={ModifyQuestionsToPaperSet} />} />
            <Route path="/admin/screenshot-component" element={<AdminRoute component={ScreenshotComponent} />} />
            <Route path="/admin/video-capture" element={<AdminRoute component={VideoCapture} />} />
            <Route path="/admin/upload-questions" element={<AdminRoute component={UploadQuestions} />} />
            <Route path="/admin/exam-result" element={<AdminRoute component={ExamResult} />} />
            <Route path="/admin/mark-sheet/:userId" element={<AdminRoute component={Marksheet} />} />
            <Route path="/admin/all-marksheet" element={<AdminRoute component={AllUsersMarksheet} />} />
            <Route path="/admin/exam-response/:userId/:paperSetId" element={<ExamResponse />} />

            <Route path="/admin/category-manager" element={<AdminRoute component={CategoryManager} />} />
            <Route path="/admin/view-categories" element={<AdminRoute component={ViewCategories} />} />
            <Route path="/admin/modify-category" element={<AdminRoute component={ModifyCategory} />} />

            <Route path="/admin/set-question-category" element={<AdminRoute component={SetQuestionCategory} />} />
            <Route path="/admin/view-questions-by-category" element={<AdminRoute component={ViewQuestionsByCategory} />} />
            <Route path="/admin/change-question-category" element={<AdminRoute component={ChangeQuestionCategory} />} />

            <Route path="/admin/mark-sheet" element={<AdminRoute component={Marksheet} />} />
            <Route path="/admin/livevideo" element={<AdminRoute component={LiveVideo} />} />
            

            <Route path="/admin" element={<AdminRoute component={AdminDashboard} />} />
            {/* <Route path="/admin/live-stream" element={<LiveStream />} /> */}
            <Route path="/user/start-exam" element={<UserRoute component={StartExam} />} />
            <Route path="/user/result" element={<UserRoute component={Result} />} />
            <Route path="/user" element={<UserRoute component={UserDashboard} />} />
            <Route path="/" element={<RequireAuth />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
};

const RequireAuth = () => {
  const { auth } = useAuth();

  if (!auth.token) {
    return <Navigate to="/login" />;
  }

  if (auth.role === 'admin') {
    return <Navigate to="/admin" />;
  }

  if (auth.role === 'user') {
    return <Navigate to="/user" />;
  }

  return null;
};

export default App;
